// React
import React from "react";
// Redux
import * as redux from "redux";
import { connect } from "react-redux";
// Domain
import { defaultTotals } from "./OverviewReport";
import * as Selector from "./selector";
import * as Actions from "./actions";
// Utils
import * as ServerPaths from "common/utils/serverPaths";
import * as reportHelper from "common/utils/reportHelper";
import DateHelper from "common/utils/DateHelper";
// Table related
import FullTable from "common/ui/components/table/FullTable";
import * as ColumnHeading from "common/ui/components/table/columnHeading";
import * as RenderAs from "common/ui/components/table/renderAs";
import { ColumnAlign, ColumnSize, ColumnMeta } from "common/ui/components/table/ColumnMeta";
// Components
import Page from "common/ui/components/page/Page";
import PageHeading from "common/ui/components/page/PageHeading";
import PageContainer from "common/ui/components/page/PageContainer";
import ReportDatePicker from "common/ui/components/datePicker/ReportDatePicker";
import DateRangeWarning from "common/ui/components/dateRangeWarning/DateRangeWarning";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./OverviewReportView.less";
const mapStateToProps = (state) => ({
    report: Selector.reportSelector(state)
});
const mapDispatchToProps = (dispatch) => ({
    actions: redux.bindActionCreators(Actions, dispatch)
});
//-- Component -------------------------------------------------------------------------------------------------------------------------------
class OverviewReportView extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        // Only fetch data if we need to
        if (reportHelper.getIfNeedsAgencyData(this.props.params.agencyId, this.props.report)) {
            this.props.actions.getForced(this.props.params.agencyId);
        }
    }
    render() {
        let { report } = this.props;
        let { reportData } = report;
        let isFetching = report.isFetching;
        let items = [];
        let fromDate = null;
        let toDate = null;
        let agencyId = -1;
        let totals = defaultTotals;
        if (reportData) {
            fromDate = reportData.startDate;
            toDate = reportData.endDate;
            agencyId = reportData.agencyId;
        }
        if (!report.isFetching) {
            items = reportData.items;
            totals = reportData.totals;
        }
        //-- Column meta data
        let metaData = [];
        metaData.push(new ColumnMeta(1, "officeId", "Office Id", ColumnSize.col1)
            .notSortable()
            .header(ColumnHeading.columnHeaderRotated).toReportColumnMeta());
        metaData.push(new ColumnMeta(2, "officeName", "Office Name", ColumnSize.auto)
            .header(ColumnHeading.columnHeaderWithSub)
            .headerProps({ subHeading: "Agency Totals:", subHeadingTip: "This shows the totals for the entire Agency", tip: "Name of the Office" })
            .component(RenderAs.renderAsOfficeLink)
            .toReportColumnMeta());
        metaData.push(new ColumnMeta(3, "totalListings", "Total Listings", ColumnSize.auto, ColumnAlign.center)
            .component(RenderAs.renderAsFormattedNumber)
            .header(ColumnHeading.columnHeaderTotals)
            .headerProps({ total: totals.totalListings, totalTip: "Total unique Listings for all offices in the selected date range", tip: "Total unique Listings for each Office in the selected date range" })
            .toReportColumnMeta());
        metaData.push(new ColumnMeta(4, "totalViews", "Total Views", ColumnSize.auto, ColumnAlign.center)
            .component(RenderAs.renderAsFormattedNumber)
            .header(ColumnHeading.columnHeaderTotals)
            .headerProps({ total: totals.totalViews, totalTip: "Total views for all offices in the selected date range", tip: "Total views for each Office in the selected date range" })
            .toReportColumnMeta());
        metaData.push(new ColumnMeta(5, "totalLeads", "Total Leads", ColumnSize.auto, ColumnAlign.center)
            .component(RenderAs.renderAsFormattedNumber)
            .header(ColumnHeading.columnHeaderTotals)
            .headerProps({ total: totals.totalLeads, totalTip: "Total leads for all offices in the selected date range", tip: "Total leads for each Office in the selected date range" })
            .toReportColumnMeta());
        metaData.push(new ColumnMeta(6, "totalSaleListings", "Sale Listings", ColumnSize.auto, ColumnAlign.center)
            .component(RenderAs.renderAsFormattedNumber)
            .header(ColumnHeading.columnHeaderTotals)
            .headerProps({ total: totals.totalSaleListings, totalTip: "Total unique Sale Listings for all offices in the selected date range", tip: "Total unique Sale Listings for each Office in the selected date range" })
            .toReportColumnMeta());
        metaData.push(new ColumnMeta(7, "totalSaleViews", "Sale Views", ColumnSize.auto, ColumnAlign.center)
            .component(RenderAs.renderAsFormattedNumber)
            .header(ColumnHeading.columnHeaderTotals)
            .headerProps({ total: totals.totalSaleViews, totalTip: "Total Sale Listing views for all offices in the selected date range", tip: "Total Sale Listing views for each Office in the selected date range" })
            .toReportColumnMeta());
        metaData.push(new ColumnMeta(8, "totalSaleLeads", "Sale Leads", ColumnSize.auto, ColumnAlign.center)
            .component(RenderAs.renderAsFormattedNumber)
            .header(ColumnHeading.columnHeaderTotals)
            .headerProps({ total: totals.totalSaleLeads, totalTip: "Total Sale Listing leads for all offices in the selected date range", tip: "Total Sale Listing leads for each Office in the selected date range" })
            .toReportColumnMeta());
        metaData.push(new ColumnMeta(9, "totalRentalListings", "Rental Listings", ColumnSize.auto, ColumnAlign.center)
            .component(RenderAs.renderAsFormattedNumber)
            .header(ColumnHeading.columnHeaderTotals)
            .headerProps({ total: totals.totalRentalListings, totalTip: "Total unique Rental Listings for all offices in the selected date range", tip: "Total unique Rental Listings for each Office in the selected date range" })
            .toReportColumnMeta());
        metaData.push(new ColumnMeta(10, "totalRentalViews", "Rental Views", ColumnSize.auto, ColumnAlign.center)
            .component(RenderAs.renderAsFormattedNumber)
            .header(ColumnHeading.columnHeaderTotals)
            .headerProps({ total: totals.totalRentalViews, totalTip: "Total Rental Listing views for all offices in the selected date range", tip: "Total Rental Listing views for each Office in the selected date range" })
            .toReportColumnMeta());
        metaData.push(new ColumnMeta(11, "totalRentalLeads", "Rental Leads", ColumnSize.auto, ColumnAlign.center)
            .component(RenderAs.renderAsFormattedNumber)
            .header(ColumnHeading.columnHeaderTotals)
            .headerProps({ total: totals.totalRentalLeads, totalTip: "Total Rental Listing leads for all offices in the selected date range", tip: "Total Rental Listing leads for each Office in the selected date range" })
            .toReportColumnMeta());
        metaData.push(new ColumnMeta(12, "totalOtherViews", "Other Views", ColumnSize.auto, ColumnAlign.center)
            .component(RenderAs.renderAsFormattedNumber)
            .header(ColumnHeading.columnHeaderTotals)
            .headerProps({ total: totals.totalOtherViews, totalTip: "Total views from non-listing sources for all offices in the selected date range (Branded Office Pages & Branded Agent Pages & Developments Views)", tip: "Total views from non-listing sources for each office in the selected date range (Branded Office Pages & Branded Agent Pages & Developments Views)" })
            .toReportColumnMeta());
        metaData.push(new ColumnMeta(13, "totalOtherLeads", "Other Leads", ColumnSize.auto, ColumnAlign.center)
            .component(RenderAs.renderAsFormattedNumber)
            .header(ColumnHeading.columnHeaderTotals)
            .headerProps({ total: totals.totalOtherLeads, totalTip: "Total leads from non-listing sources for all offices in the selected date range (Branded Office Pages & Branded Agent Pages & Developments & Billboards Leads)", tip: "Total leads from non-listing sources for each office in the selected date range (Branded Office Pages & Branded Agent Pages & Developments & Billboards Leads)" })
            .toReportColumnMeta());
        //-- Handle date change
        let datePick = (fromDate, toDate) => {
            this.props.actions.getForced(agencyId, fromDate, toDate);
        };
        let ranges = {
            'Last 30 Days': DateHelper.getLast30Days(),
            'This Month': DateHelper.getThisMonth(),
            'Last Month': DateHelper.getLastMonth()
        };
        let datePickerComponent = (React.createElement(ReportDatePicker, { fromDate: fromDate, toDate: toDate, isFetching: isFetching, dateRange: ranges, onSelect: (from, to) => datePick(from, to) }));
        // Return
        return (React.createElement(Page, { className: styles.container },
            React.createElement(PageHeading, { reportName: "Agency Overview", datePicker: datePickerComponent },
                React.createElement("a", { target: "_blank", href: ServerPaths.agencyOverviewRequestCsvParams(agencyId, fromDate, toDate) }, "Export")),
            React.createElement(PageContainer, { isFetching: isFetching },
                React.createElement("div", { className: styles.container },
                    React.createElement(DateRangeWarning, { fromDate: fromDate, toDate: toDate }),
                    React.createElement(FullTable, { reportItems: items, metaData: metaData, excludeColumns: ["officeId", "totalMessageLeads", "totalTelephoneLeads", "totalSaleMessageLeads",
                            "totalSaleTelephoneLeads", "totalRentalMessageLeads", "totalRentalTelephoneLeads"], excludeColumnsFromFilter: ["officeId", "totalListings", "totalViews", "totalLeads",
                            "totalSaleListings", "totalSaleViews", "totalSaleLeads",
                            "totalRentalListings", "totalRentalViews", "totalRentalLeads",
                        ], initialSort: "officeName" })))));
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(OverviewReportView);
